import type { PlatformId, PromptDocument } from '../types'
import { midjourneyRenderer } from './midjourney'
import { stableDiffusionRenderer } from './stableDiffusion'
import { imagenRenderer } from './imagen'
import { doubaoRenderer } from './doubao'

export interface PlatformRenderer {
  id: PlatformId
  label: string
  render: (doc: PromptDocument) => string
}

const rendererList: PlatformRenderer[] = [
  midjourneyRenderer,
  stableDiffusionRenderer,
  imagenRenderer,
  doubaoRenderer,
]

const rendererMap: Record<PlatformId, PlatformRenderer> = rendererList.reduce(
  (acc, r) => {
    acc[r.id] = r
    return acc
  },
  {} as Record<PlatformId, PlatformRenderer>,
)

export function getRenderer(platform: PlatformId): PlatformRenderer {
  return rendererMap[platform] ?? midjourneyRenderer
}

export function listRenderers(): PlatformRenderer[] {
  return rendererList.slice()
}

export function renderPrompt(doc: PromptDocument, platform: PlatformId): string {
  return getRenderer(platform).render(doc)
}

export { midjourneyRenderer, stableDiffusionRenderer, imagenRenderer, doubaoRenderer }
